<script>
import platformjs from '/vodalys/vlib/js/platform.min.js';

export default {
  methods: {},
  props: ["handler", "instance"],
  translate25Context: 'troubleshooting',
  data() {
    return {
      platformjs: {},
      checkPlatform: 'pending',
    };
  },
  methods: {

  },
  async mounted() {
    this.component = this.instance["troubleshooting_app:api"]?.component;

    this.platformjs = platformjs;
    this.checkPlatform = ['Chrome'].filter(function(a){return platformjs.name.indexOf(a) > -1;}).length > 0 ? 'ok' : 'ko';

  },
  watch: {}
};
</script>

<template>
  <div class="troubleshooting-app">
    <troubleshooting-page :title="$vt('App prerequises')">
      <template #content>

        <div class="list">
          <div class="title">{{ $vt('Domains') }}</div>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_app:api'].component.app"></troubleshooting-page-http-status>

          <troubleshooting-page-websocket-status
            :component="instance['troubleshooting_app:api'].component.nodejs"></troubleshooting-page-websocket-status>

          <troubleshooting-page-websocket-status
            :component="instance['troubleshooting_app:api'].component.vruncache"></troubleshooting-page-websocket-status>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_app:api'].component.vnginx.http"></troubleshooting-page-http-status>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_app:api'].component.vnginx.rtmp"></troubleshooting-page-http-status>

          <span class="troubleshooting-app-wowzas" v-for="wowza in instance['troubleshooting_app:api'].component.wowzas"
            :key="wowza['#id']">

            <troubleshooting-page-http-status :component="wowza.http"></troubleshooting-page-http-status>

            <troubleshooting-page-webRTC-status :component="wowza.rtmp"></troubleshooting-page-webRTC-status>

          </span>
        </div>

        <div class="bandwith list">
          <div class="title">{{ $vt('Network requirement') }}</div>
          <troubleshooting-bandwith
            :component="instance['troubleshooting_app:api'].component.bandwith"></troubleshooting-bandwith>
        </div>

        <div class="list">
          <div class="title">{{ $vt('Browser') }}</div>
          <troubleshooting-page-status :status="checkPlatform">
            <template #content>{{ platformjs.description }}</template></troubleshooting-page-status>
          <f-hint v-if="checkPlatform == 'ko'" type="negative" icon="fa6-triangle-exclamation">
            <template #message>{{ $vt('Vodalys Studio is optimized for') }} <a target="_blank"
                href="https://www.google.com/chrome/">Google Chrome</a><br />
            </template>
          </f-hint>
        </div>

      </template>
    </troubleshooting-page>
  </div>
</template>

<style lang="scss">
.troubleshooting-app {
  width: 100%;
  height: 100%;
  overflow: auto;

  .troubleshooting-app-wowzas {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>